import { useRouter } from 'helpers/navigation'
import React, { FC } from 'react'
import styled, { css } from 'styled-components'
import ImageBox from 'uiComponents/atoms/ImageBox/ImageBox'

const Tile = styled.div<{ isLink: boolean }>`
  position: relative;
  width: 100%;
  height: 100%;
  ${props =>
    props.isLink &&
    css`
      cursor: pointer;
    `};
`

const fullAbsolute = css`
  position: absolute;
  width: 100%;
  height: 100%;
`
const Gradient = styled.div`
  ${fullAbsolute};
  background-image: linear-gradient(#000, rgba(0, 0, 0, 0.3) 0%);
  top: 0;
`

const ContentWrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`

const StyledImageBox = styled(ImageBox)`
  width: 100%;
  height: 100%;
`
const ImageTile: FC<
  React.PropsWithChildren<{ imageUrl: string; href?: string }>
> = ({ imageUrl, href, children }) => {
  const { navigateClient } = useRouter()

  return (
    <Tile isLink={Boolean(href)} onClick={() => href && navigateClient(href)()}>
      <Gradient />
      <StyledImageBox src={imageUrl} />
      <ContentWrapper>{children}</ContentWrapper>
    </Tile>
  )
}

export default ImageTile
